module.exports = __webpack_public_path__ + "static/media/besu-bg.8330043e.png";